
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/full-stack",
      function () {
        return require("private-next-pages/full-stack/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/full-stack"])
      });
    }
  